// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textbox = "TextField__textbox__qnJkJ";
export const textboxInner = "TextField__textboxInner__H2UxG";
export const showLabelAsLink = "TextField__showLabelAsLink__odmLh";
export const active = "TextField__active__bYrCW";
export const red = "TextField__red__tUwlX";
export const yellow = "TextField__yellow__AhPKP";
export const green = "TextField__green__3Y1bD";
export const inputWrapper = "TextField__inputWrapper__6mY7b";
export const withEllipsis = "TextField__withEllipsis__0PEPY";
export const ellipsisGray = "TextField__ellipsisGray__FKAJU";
export const ellipsisSnow = "TextField__ellipsisSnow__ACK9d";
export const ellipsisDark = "TextField__ellipsisDark__EsFJ6";
export const textSecurity = "TextField__textSecurity__3PJP9";
export const input = "TextField__input__LP4VK font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const decoration = "TextField__decoration__4dmap";
export const withValue = "TextField__withValue__dyoqx";
export const labelWrapper = "TextField__labelWrapper__O42l3";
export const label = "TextField__label__Al9yK font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const error = "TextField__error__Q8bjH";
export const disabled = "TextField__disabled__m5y1l";
export const textBoxSpinner = "TextField__textBoxSpinner__NvVpo";
export const errorsWrapper = "TextField__errorsWrapper__mLqD9 font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const singleError = "TextField__singleError__TVfh8";
export const multipleErrors = "TextField__multipleErrors__hTzW4";
export const errorList = "TextField__errorList__tvm6i";
export const errorListItem = "TextField__errorListItem__yJLrF";
export const rule = "TextField__rule__gQaTz";
export const guideline = "TextField__guideline__GzyXm";
export const ruleDot = "TextField__ruleDot__MwZ5X";
export const ruleCheckmark = "TextField__ruleCheckmark__Nf-60";
export const validRule = "TextField__validRule__uNYny";
export const tooltipIconWrapper = "TextField__tooltipIconWrapper__pQtmg TooltipIcon__tooltipIconWrapper__oUGNC";
export const labelText = "TextField__labelText__q8Gf-";